import React from 'react';
import {switchApi, authCheck, getManagers, getManager, addManager, editManager, delManager} from '../Api';
import Modal from '../components/Modal';
import ModalManager from '../components/ModalManager';
import $ from 'jquery';
import Toast from '../components/Toast';
import Sidebar from '../components/Sidebar';
import ManagerTable from '../components/ManagerTable';

export default class PageManagers extends React.Component {

    state = {
        toasts: [],
        managers: [],
        manager: {},
        _id: 0,
        _company: '',
        _address: '',
        _description: '',
        _phone: '',
        _email: '',
        _firstName: '',
        _lastName: '',
        _password: '',
        _poolUrl: '',
        _poolUser: '',
        _poolPass: '',
    }

    toast(title, content){
        let toasts = this.state.toasts;
        let i = toasts.push({
            title: title,
            content: content
        });
        this.setState({toasts},()=>{
            $('#toast_'+(i-1)).toast({delay: 5000});
            $('#toast_'+(i-1)).toast('show');
        });        
    }

    componentDidMount(){
        this.isMount = true;
        this.apiAuthCheck();
    }

    componentWillUnmount(){
        this.isMount = false;
    }

    changeState(state, value){
        if (this.isMount) this.setState({[state]: value});
    }

    
    apiAuthCheck(){
        authCheck()
        .then((data)=>{
            if ((data.status === 200)&&(data.data.user)){
                if (this.isMount) this.setState({user: data.data.user});
                this.apiGetManagers();
            }else{
                console.log(data);
                this.props.history.push('/');
            }          
        })
        .catch((err)=>{
            console.log(err);
            if (err.code === 'ECONNABORTED') {
                switchApi();
                this.apiAuthCheck();
            }else{
                this.props.history.push('/');
            }
        });
    }


    apiGetManagers(){
        getManagers()
        .then((data)=>{
            if ((data.status === 200)&&(data.data.managers)){
                if (this.isMount) this.setState({managers: data.data.managers});                
            }else{
                console.log(data);
            }          
        })
        .catch((err)=>{
            console.log(err);
            //this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }


    modalAddManager(){
        this.setState({
            _company: '',
            _address: '',
            _description: '',
            _phone: '',
            _email: '',
            _firstName: '',
            _lastName: '',
            _password: '',
            _poolUrl: '',
            _poolUser: '',
            _poolPass: '',
        }, ()=>{
            $('#modalAddManager').modal('show');
        });
    }


    apiAddManager(){
        addManager({
            company: this.state._company,
            address: this.state._address,
            description: this.state._description,
            phone: this.state._phone,
            email: this.state._email,
            firstName: this.state._firstName,
            lastName: this.state._lastName,
            password: this.state._password,
            poolUrl: this.state._poolUrl,
            poolUser: this.state._poolUser,
            poolPass: this.state._poolPass,
        })
        .then((data)=>{
            if ((data.status === 200)&&(!data.data.error)){
                $('#modalAddManager').modal('hide');
                this.toast('Success', 'Saved');
                this.apiGetManagers();
            }else{
                this.toast('Error', JSON.stringify(data.data.error));
            }          
        })
        .catch((err)=>{
            console.log(err);
            //this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });     
    }


    modalEditManager(i){
        let _id = this.state.managers[i].id;
        getManager(_id)
        .then((data)=>{
            if ((data.status === 200)&&(data.data.manager)){
                if (this.isMount) this.setState({
                    _id,
                    _company: (data.data.manager.company) ? data.data.manager.company : '',
                    _address: (data.data.manager.address) ? data.data.manager.address : '',
                    _description: (data.data.manager.description) ? data.data.manager.description : '',
                    _phone: (data.data.manager.phone) ? data.data.manager.phone : '',
                    _email: (data.data.manager.email) ? data.data.manager.email : '',
                    _firstName: (data.data.manager.firstName) ? data.data.manager.firstName : '',
                    _lastName: (data.data.manager.lastName) ? data.data.manager.lastName : '',
                    _poolUrl: (data.data.manager.poolUrl) ? data.data.manager.poolUrl : '',
                    _poolUser: (data.data.manager.poolUser) ? data.data.manager.poolUser : '',
                    _poolPass: (data.data.manager.poolPass) ? data.data.manager.poolPass : '',
                }, ()=>{
                    $('#modalEditManager').modal('show');
                });
            }else{
                this.toast('Error', JSON.stringify(data.data.error));
            }          
        })
        .catch((err)=>{
            console.log(err);
            //this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }


    apiEditManager(){
        editManager(this.state._id, {
            company: this.state._company,
            address: this.state._address,
            description: this.state._description,
            phone: this.state._phone,
            email: this.state._email,
            firstName: this.state._firstName,
            lastName: this.state._lastName,
            poolUrl: this.state._poolUrl,
            poolUser: this.state._poolUser,
            poolPass: this.state._poolPass,
        })
        .then((data)=>{
            if ((data.status === 200)&&(!data.data.error)){
                $('#modalEditManager').modal('hide');
                this.toast('Success', 'Saved');
                this.apiGetManagers();
            }else{
                this.toast('Error', JSON.stringify(data.data.error));
            }          
        })
        .catch((err)=>{
            console.log(err);
            //this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }


    modalDelManager(i){
        let _id = this.state.managers[i].id;
        this.setState({
            _id
        }, ()=>{
            $('#modalDelManager').modal('show');
        });
    }


    apiDelManager(){
        delManager(this.state._id)
        .then((data)=>{
            if ((data.status === 200)&&(!data.data.error)){
                $('#modalDelManager').modal('hide');
                this.toast('Success', 'Deleted');
                this.apiGetManagers();
            }else{
                this.toast('Error', JSON.stringify(data.data.error));
            }          
        })
        .catch((err)=>{
            console.log(err);
            //this.props.history.push('/');
            this.toast('Error', JSON.stringify(err.message));
        });
    }


    render() {
        return (
            (!this.state.user)
            ?<div className="app"></div>
            :<div className="app">
                <Sidebar history={this.props.history} user={this.state.user} customer={this.state.customer} customerId={this.state.customerId}/>
                <div className="app-content">
                    <div className="page page-users">
                        <div className="toasts">
                            {(this.state.toasts) &&
                                this.state.toasts.map((toast, i)=>{
                                    return <Toast key={i} id={'toast_'+i} title={toast.title} content={toast.content} />
                                })
                            }
                        </div>
                        <div className="row">
                            <div className="col">
                                <h1 className="page-title">Managers
                                </h1>
                            </div>
                            <div className="col text-right">
                                {(this.state.user.userType.permissions.find((el) => el.id === 11)) &&
                                    <button className="btn btn-primary"
                                    onClick={this.modalAddManager.bind(this)}
                                    >New Manager</button>
                                }
                            </div>
                        </div>             
                        <div className="row">
                            <div className="col-lg-12 mt-4">
                                <ManagerTable 
                                    user={this.state.user}
                                    managers={this.state.managers}
                                    editFunction={this.modalEditManager.bind(this)}
                                    deleteFunction={this.modalDelManager.bind(this)}
                                />
                            </div>
                        </div>                
                    </div>
                </div>
                <ModalManager
                    id="modalAddManager"
                    title="Add Manager"
                    changeState={this.changeState.bind(this)}
                    saveFunction={this.apiAddManager.bind(this)}
                    _company = {this.state._company}
                    _address = {this.state._address}
                    _description = {this.state._description}
                    _phone = {this.state._phone}
                    _email = {this.state._email}
                    _firstName = {this.state._firstName}
                    _lastName = {this.state._lastName}
                    _password = {this.state._password}
                    _poolUrl = {this.state._poolUrl}
                    _poolUser = {this.state._poolUser}
                    _poolPass = {this.state._poolPass}
                />
                <ModalManager
                    id="modalEditManager"
                    title="Edit Manager"
                    changeState={this.changeState.bind(this)}
                    saveFunction={this.apiEditManager.bind(this)}
                    _company = {this.state._company}
                    _address = {this.state._address}
                    _description = {this.state._description}
                    _phone = {this.state._phone}
                    _email = {this.state._email}
                    _firstName = {this.state._firstName}
                    _lastName = {this.state._lastName}
                    _poolUrl = {this.state._poolUrl}
                    _poolUser = {this.state._poolUser}
                    _poolPass = {this.state._poolPass}
                />
                <Modal 
                    id="modalDelManager"
                    title="Delete Manager"
                    content="Are you sure?"
                    confirmText="Delete"
                    confirmFunction={this.apiDelManager.bind(this)}
                />    
            </div>        
        );
    }
}